import React from 'react';
import { useNavigate } from 'react-router-dom';
import CompanyLayout from '../components/CompanyLayout';
import JobPostingForm from '../components/JobPostingForm';
import { COMPANY_ROUTES } from '../constants';

const JobPosting: React.FC = () => {
    const navigate = useNavigate();

    return (
        <CompanyLayout>
            {/* Back Button */}
            <button
                onClick={() => navigate(COMPANY_ROUTES.JOB_POSTINGS)}
                className="mb-6 hover:opacity-70 transition-opacity"
            >
                <img src="/jobs/back_button.svg" alt="Back" className="w-6 h-6" />
            </button>

            <div className="mb-6">
                <h1 className="text-2xl font-semibold text-[#0B111E]" style={{ fontFamily: 'Manrope, sans-serif' }}>
                    Post New Job
                </h1>
            </div>

            <JobPostingForm />
        </CompanyLayout>
    );
};

export default JobPosting;
